// Which URLs belong to the behmn marketing site (as opposed to the platform).
import { APP_SEGMENTS } from '@/lib/app-segments.generated'
import { BEHMN_PAGES } from './pages.generated'

const ROUTES: ReadonlySet<string> = new Set(BEHMN_PAGES.map((p) => p.route).filter((r): r is NonNullable<typeof r> => r !== null))

/** A marketing page, or a URL that matches no route at all (those get the marketing 404). */
export function isMarketingPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  if (ROUTES.has(path)) return true
  return !APP_SEGMENTS.includes(path.split('/')[1] ?? '')
}
